<mat-spinner *ngIf="isLoading" color="accent"></mat-spinner>
<div class="top-section">
    <span style="float: left">
        <button type="button" class="btn secondary" (click)="goBack()">Go back</button>
        <ng-container *ngIf="hasRowData()">
            <button
                type="button"
                style="margin-left: 10px"
                class="btn secondary"
                (click)="showFileSummary()"
            >
                Summary
            </button>
        </ng-container>
    </span>
</div>
<div
    *ngIf="uploadedFiles.length === 0"
    class="custom-container"
    appSbUploadWithPreview
    (fileDropped)="onFileDropped($event)"
>
    <input
        type="file"
        #fileDropRef
        id="fileDropRef"
        accept="”.csv”"
        (change)="fileBrowseHandler($event.target.files)"
    />
    <span class="material-icons">cloud_upload</span>
    <h3>Drag and drop .csv file here</h3>
    <h3>or</h3>
    <label for="fileDropRef">Choose File</label>
</div>
<div class="files-list">
    <div class="single-file" *ngFor="let file of uploadedFiles; let i = index">
        <div class="file-icon">
            <span class="material-icons">description</span>
        </div>
        <div class="info">
            <h4 class="name">
                {{ file?.name }}
            </h4>
            <p class="size">
                {{ formatBytes(file?.size) }}
            </p>
        </div>
        <div class="upload">
            <button class="btn primary" (click)="onUpload($event)">
                {{ getLabel() }}
            </button>
        </div>
        <div class="delete">
            <button class="btn secondary" (click)="deleteFile(i)">Cancel</button>
        </div>
    </div>
</div>

<div *ngIf="uploadedFiles.length > 0 && rowData.length > 0">
    <span style="float: right">
        Show remarks only
        <mat-checkbox [(ngModel)]="remarksOnly" [binary]="true"></mat-checkbox>
    </span>
    <div class="card" style="clear: both">
        <ag-grid-angular
            #agGrid
            style="width: auto"
            class="ag-theme-material"
            [rowData]="getRowData()"
            [columnDefs]="columnDefs"
            [tooltipShowDelay]="tooltipShowDelay"
            [frameworkComponents]="frameworkComponents"
            [defaultColDef]="defaultColDef"
            [gridOptions]="gridOptions"
            [pagination]="true"
            (gridReady)="onGridReady($event)"
            [paginationPageSize]="paginationPageSize"
        ></ag-grid-angular>
    </div>
</div>
